import React, { useContext, useState, useEffect } from 'react';
import { Row, Col, Modal, ModalBody } from 'reactstrap';
import { Link, useNavigate } from 'react-router-dom';
import ImageComponent from '../components/common/ImageComponent';
import ProfileAvatar from '../components/common/ProfileAvatar';
import VideoWithAspectRatio from '../components/common/VideowithAspectRatio.tsx';
import ImageWithAspectRatio from '../components/common/ImagewithAspectRatio';
import PostMediaGallery from '../components/feeds/cards/PostMediaGallery';
import PostHeader from '../components/feeds/cards/PostHeader';
import PostFooter from '../components/feeds/cards/PostFooter';
import PollOptionsView from './PollOptionsView';
import PollResultsView from './PollResultsView';
import { PROFILE } from '../constants/RoutesUrl';
import { toast } from 'react-toastify';
import { GoClock, GoScreenFull } from 'react-icons/go';
import Avatar from "../assets/images/icon/placeholder_Awatar.png";
import { _imagesURL } from '../constants/API';
import { Language } from '../App';
import { IoCalendarOutline, IoCloseSharp } from 'react-icons/io5';
import { MdOutlineMedicalServices } from 'react-icons/md';
import { ReadMore } from '../components/common/ReadMore.jsx';

const PostCard = ({
  value,
  postDropDown,
  setPostDropDown,
  setReportModal,
  setDropDownId,
  dropDownId,
  handleRepost,
  handleSave,
  handleFollow,
  setShowPost,
  editWebinarTab,
  editPostTab,
  setEditPost,
  editPost,
  handlePostSelect,
  updatePost,
  deletePost,
  updatePostDetail,
  handleLikeUsers,
  handleLike,
  handleGetComments,
  setPostModal,
  setPostId,
  handleReserveWebinar,
  handlePollAnswer,
  toggleModal,
  removePollAnswer,
  refetch,
  playingVideo,
  handleVideoPlay,
  indicatorStyles
}) => {
  const navigate = useNavigate();
  const { lang } = useContext(Language)
  const userData = localStorage.getItem("SignupData");
  const user = userData ? JSON.parse(userData) : null;
  const user_id = user?.data?.id;
  const [pdfModalOpen, setPdfModalOpen] = useState(false);
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [fileToView, setFileToView] = useState({ type: null, media: null });
  const [isChrome, setIsChrome] = useState(false);

  const toggleFullScreen = () => {
    setIsFullScreen(!isFullScreen);
  };

  useEffect(() => {
    // Check if the browser is Chrome
    const userAgent = navigator.userAgent.toLowerCase();
    if (
      userAgent.indexOf("chrome") > -1 &&
      userAgent.indexOf("edge") === -1
    ) {
      setIsChrome(true);
    }
  }, []);

  const closeModal = () => {
    setPdfModalOpen(false); // Close the modal
    setFileToView(null); // Clear the file to view state
  };

  const repostCaptionText =
    (value.repost_caption && typeof value.repost_caption === "string" && value.repost_caption.trim()) ||
    (value.repost_user?.repost_caption && typeof value.repost_user.repost_caption === "string" && value.repost_user.repost_caption.trim()) ||
    (value.type === "poll" && value.repost_user?.name && value.caption && value.caption !== "..." && value.caption.trim()) ||
    "";

  const renderRepostHeader = () => {
    if (!value.repost_user?.name) return null;

    return (
      <div
        className="px-3 px-sm-4 py-2.5 mb-2"
        style={{
          background: "#F8FAFC",
          borderBottom: "1px solid #F1F5F9",
          borderTopLeftRadius: "20px",
          borderTopRightRadius: "20px",
        }}
      >
        <div className="d-flex align-items-center">
          <ProfileAvatar
            src={value.repost_user.image}
            size={36}
            variant="cyan"
            link={`${PROFILE}/${value.repost_user.user_name || value.repost_user.id}`}
            alt={value.repost_user.name || "Repost user"}
          />
          <div className="ms-3 align-self-center">
            <p className="mb-0 fs-13 roboto-medium" style={{ color: "#0F1A2B" }}>
              <Link className="hover-blue text-dark fw-bold" to={`${PROFILE}/${value.repost_user.user_name || value.repost_user.id}`}>
                {value.repost_user.name}
              </Link>{" "}
              <span style={{ color: "#5F6673", fontWeight: 400 }}>{lang?.reposted_this || "reposted this"}</span>
            </p>
          </div>
        </div>

        {repostCaptionText && (
          <div className="mt-2 pt-1 ps-1" style={{ color: "#0F1A2B", fontSize: "14px", lineHeight: "1.55" }}>
            <ReadMore text={repostCaptionText} />
          </div>
        )}
      </div>
    );
  };

  const renderMedia = () => {
    if (!value.media?.length) return null;

    const mediaSize = Number(value.sizes) > 0 ? Number(value.sizes) : 1.78;

    if (value.type === "video") {
      return value.media.map((media, index) => (
        <VideoWithAspectRatio
          key={index}
          index={index}
          src={_imagesURL + media}
          aspectRatio={mediaSize}
          setPlayingVideo={handleVideoPlay}
          playingVideo={playingVideo}
          onVideoTap={() => {
            if (value.type === "webinar") {
              navigate(`/webinar/${value.seo_slug || value.id}`, { state: { webinarData: value } });
            } else {
              updatePostDetail(value);
            }
          }}
        />
      ));
    }

    if (value.media.length === 1) {
      return value.media.map((media, index) => (
        <ImageWithAspectRatio
          key={index}
          sizes={mediaSize}
          aspectRatio={mediaSize}
          src={_imagesURL + media}
          alt={value.title || "Medical post media"}
        />
      ));
    }

    return (
      <PostMediaGallery
        media={value.media}
        sizes={mediaSize}
        onImageClick={() => {
          if (value.type === "webinar") {
            navigate(`/webinar/${value.seo_slug || value.id}`, { state: { webinarData: value } });
          } else {
            updatePostDetail(value);
          }
        }}
      />
    );
  };

  const renderWebinarContent = () => {
    const formatDate = (dateString) => {
      const date = new Date(dateString);
      return date.toLocaleDateString("en-GB", {
        weekday: "short",
        day: "2-digit",
        month: "short",
        year: "numeric",
      });
    };
    function handleWebinarClick(val) {
      const isCreator =
        (val?.user?.id && user_id && String(val.user.id) === String(user_id)) ||
        (val?.user_id && user_id && String(val.user_id) === String(user_id)) ||
        Boolean(val?.is_creator || val?.isCreator || val?.is_owner);

      const isHost = Boolean(val?.isHost || val?.is_host || val?.host) || isCreator;

      const rawStatus = val?.status;
      const isLive =
        rawStatus === 1 ||
        rawStatus === "1" ||
        rawStatus === "started" ||
        rawStatus === "live" ||
        rawStatus === "in_progress" ||
        Boolean(val?.is_live || val?.isLive);

      const isEnded =
        rawStatus === 2 ||
        rawStatus === "2" ||
        rawStatus === "ended" ||
        rawStatus === "completed";

      const isReserve = Boolean(val?.isReserve || val?.is_reserved || val?.isJoined || val?.is_joined);

      const hostMeetingUrl =
        val?.meeting_host_url ||
        val?.meeting_url ||
        val?.meta?.meeting_url ||
        val?.room_url ||
        val?.link;

      const attendeeMeetingUrl =
        val?.meeting_url ||
        val?.meeting_host_url ||
        val?.meta?.meeting_url ||
        val?.room_url ||
        val?.link;

      if (isEnded) {
        toast.info(lang?.webinar_is_ended || lang?.webinar_ended || "Webinar Ended");
        return;
      }

      if (isCreator) {
        if (isLive) {
          if (hostMeetingUrl) {
            window.open(hostMeetingUrl, "_blank");
            return;
          }
          toast.info(lang?.meeting_url_not_available || "Meeting room link not available yet.");
          return;
        }
        // Upcoming / not live: Edit Webinar
        if (handlePostSelect) {
          handlePostSelect(val);
        }
        if (editWebinarTab) {
          editWebinarTab(true);
        } else {
          navigate(`/webinar/${val?.seo_slug || val?.id || val?.original_id}`);
        }
        return;
      }

      if (isHost) {
        if (isLive) {
          if (hostMeetingUrl) {
            window.open(hostMeetingUrl, "_blank");
            return;
          }
          toast.info(lang?.meeting_url_not_available || "Meeting room link not available yet.");
          return;
        }
        toast.info(lang?.webinar_starts_soon || lang?.meeting_link_not_available || "Meeting room link is being prepared...");
        return;
      }

      if (isLive) {
        if (attendeeMeetingUrl) {
          if (!isReserve) {
            handleReserveWebinar(val?.id || val?.original_id);
          }
          window.open(attendeeMeetingUrl, "_blank");
        } else {
          toast.info(lang?.meeting_url_not_available || "Meeting URL not available yet.");
        }
        return;
      }

      // Upcoming
      handleReserveWebinar(val?.id || val?.original_id);
    }

    function getWebinarButtonText(val) {
      const isCreator =
        (val?.user?.id && user_id && String(val.user.id) === String(user_id)) ||
        (val?.user_id && user_id && String(val.user_id) === String(user_id)) ||
        Boolean(val?.is_creator || val?.isCreator || val?.is_owner);

      const isHost = Boolean(val?.isHost || val?.is_host || val?.host) || isCreator;

      const rawStatus = val?.status;
      const isLive =
        rawStatus === 1 ||
        rawStatus === "1" ||
        rawStatus === "started" ||
        rawStatus === "live" ||
        rawStatus === "in_progress" ||
        Boolean(val?.is_live || val?.isLive);

      const isEnded =
        rawStatus === 2 ||
        rawStatus === "2" ||
        rawStatus === "ended" ||
        rawStatus === "completed";

      const isReserve = Boolean(val?.isReserve || val?.is_reserved || val?.isJoined || val?.is_joined);

      if (isEnded) return lang?.webinar_ended || "Webinar Ended";
      if (isCreator) return isLive ? (lang?.start_webinar || "Start Webinar") : (lang?.edit_webinar || "Edit Webinar");
      if (isHost) return lang?.join_as_a_host || lang?.join_as_host || "Join as a host";
      if (isLive) return lang?.join_webinar || lang?.join_live_webinar || "Join Webinar";
      return isReserve ? (lang?.unreserve || "Unreserve") : (lang?.reserve_seat || "Reserve Seat");
    }

    const webinarStatus = getWebinarButtonText(value);
    const webinarDate = formatDate(value.schedule_date);
    if (value.type !== "webinar") return null;

    const isUnreserve = webinarStatus === "Unreserve Seat" || webinarStatus === (lang?.unreserve || "Unreserve");
    const isLive = value.status === 1 || value.status === "1" || value.status === "live" || Boolean(value?.is_live || value?.isLive);
    const isEnded = value.status === 2 || value.status === "2" || value.status === "ended";

    let btnBg = "#0F172A";
    if (isUnreserve) {
      btnBg = "#EF4444";
    } else if (isLive) {
      btnBg = "#0284C7";
    } else if (isEnded) {
      btnBg = "#94A3B8";
    }

    return (
      <div className="mx-2 mx-sm-3 my-2 d-flex flex-column flex-sm-row justify-content-between align-items-stretch align-items-sm-center mr-webinar-schedule-banner">
        <div className="d-flex flex-wrap align-items-center gap-2 gap-sm-3 mr-webinar-schedule-info">
          <div className="d-flex align-items-center gap-2 mr-webinar-chip">
            <div className="mr-webinar-icon-circle">
              <GoClock size={14} color="#0284C7" />
            </div>
            <span className="roboto-medium fs-13" style={{ color: "#0F1A2B" }}>
              {value.schedule_time}
            </span>
          </div>

          <div className="d-flex align-items-center gap-2 mr-webinar-chip">
            <div className="mr-webinar-icon-circle">
              <IoCalendarOutline size={14} color="#0284C7" />
            </div>
            <span className="roboto-medium fs-13" style={{ color: "#0F1A2B" }}>
              {webinarDate}
            </span>
          </div>
        </div>

        <button
          type="button"
          className="mr-webinar-action-btn flex-shrink-0"
          style={{
            background: btnBg,
          }}
          onClick={() => handleWebinarClick(value)}
        >
          {isLive && (
            <span
              className="d-inline-block rounded-circle me-1.5 align-middle"
              style={{
                width: "7px",
                height: "7px",
                background: "#22C55E",
                boxShadow: "0 0 6px #22C55E",
              }}
            />
          )}
          {webinarStatus}
        </button>
      </div>
    );
  };

  const renderClinicalContent = () => {
    if (value.type !== "clinical-image" || !value?.pdf) return null;

    return (
      <div className="mx-2 mx-sm-3 my-2 d-flex flex-column flex-sm-row justify-content-between align-items-stretch align-items-sm-center mr-clinical-study-banner">
        <div className="mr-clinical-info-wrap">
          <div className="mr-clinical-icon-badge">
            <MdOutlineMedicalServices size={22} />
          </div>
          <div className="min-w-0 flex-grow-1">
            <div className="roboto-bold text-truncate" style={{ color: "#065F46", fontSize: "14.5px" }}>
              {lang?.clinical_case_study || "Clinical Case Study"}
            </div>
            <div className="roboto-regular text-truncate" style={{ fontSize: "12.5px", color: "#047857" }}>
              {lang?.view_full_case_documentation || "Full clinical documentation & findings"}
            </div>
          </div>
        </div>

        <button
          type="button"
          className="mr-clinical-action-btn flex-shrink-0"
          onClick={() => updatePostDetail(value)}
        >
          {lang?.view_Case_Study || "View Case Study"}
        </button>
      </div>
    );
  };

  const renderPollContent = () => {
    if (value.type !== "poll") return null;

    return value.right === 0 && user_id !== value.user?.id ? (
      <PollOptionsView
        value={value}
        handlePollAnswer={handlePollAnswer}
        toggleModal={toggleModal}
      />
    ) : (
      <PollResultsView
        value={value}
        toggleModal={toggleModal}
        removePollAnswer={removePollAnswer}
      />
    );
  };

  return (
    <div
      className="my-3 py-3 position-relative overflow-hidden mr-feed-post-card"
      style={{
        borderRadius: "24px",
        border: "1px solid #D7E0EA",
        background: "linear-gradient(180deg, #FFFFFF 0%, #F8FDFF 100%)",
        boxShadow: "0px 8px 30px rgba(0, 186, 218, 0.06), 0px 2px 8px rgba(0, 0, 0, 0.03)",
      }}
    >
      {/* Subtle Decorative Ambient Glow (Mentorship Theme) */}
      <div
        style={{
          position: "absolute",
          top: "-30px",
          right: "-30px",
          width: "140px",
          height: "140px",
          background: "#00BADA",
          opacity: "0.15",
          filter: "blur(50px)",
          borderRadius: "50%",
          pointerEvents: "none",
          zIndex: 1,
        }}
      />

      {renderRepostHeader()}

      <PostHeader
        refetch={refetch}
        postDetails={value}
        postDropDown={postDropDown}
        setPostDropDown={setPostDropDown}
        setReportModal={setReportModal}
        setDropDownId={setDropDownId}
        dropDownId={dropDownId}
        handleRepost={handleRepost}
        isShare={value.isShare}
        isSave={value.isSave}
        handleSave={handleSave}
        shares_count={value.shares_count}
        type={value.type}
        isFollow={value.user?.follow}
        handleFollow={handleFollow}
        setShowPost={setShowPost}
        editWebinarTab={editWebinarTab}
        editPostTab={editPostTab}
        setEditPost={setEditPost}
        editPost={editPost}
        handlePostSelect={handlePostSelect}
        updatePost={updatePost}
        deletePost={deletePost}
      />

      <Row className="pt-2 px-2 px-sm-3 mr-post-media-row">
        <Col>
          <div
            className="overflow-hidden cursor"
            style={{
              borderRadius: "16px",
              border: value.media?.length ? "1px solid #F1F5F9" : "none",
            }}
            onClick={() => {
              if (value.type === "webinar") {
                navigate(`/webinar/${value.seo_slug || value.id}`, { state: { webinarData: value } });
              } else {
                updatePostDetail(value);
              }
            }}
          >
            {renderMedia()}
          </div>
        </Col>
      </Row>

      {(value?.title || (value.type !== "poll" && (value?.original_caption || (value?.caption && value.caption !== repostCaptionText)))) && (
        <div
          className="my-2 px-2 px-sm-3 mr-post-caption-box"
          style={{
            padding: "8px 12px",
          }}
        >
          <div className="w-100">
            {value?.title && (
              <h5
                className={`mb-1 roboto-bold ${value.type === "webinar" || value.type === "clinical-image" ? "cursor" : ""}`}
                style={{ color: "#0F1A2B", fontSize: "16px", lineHeight: 1.4 }}
                onClick={() => {
                  if (value.type === "webinar") {
                    navigate(`/webinar/${value.seo_slug || value.id}`, { state: { webinarData: value } });
                  } else if (value.type === "clinical-image") {
                    updatePostDetail(value);
                  }
                }}
              >
                {value.title}
              </h5>
            )}
            {value.type !== "poll" && (value?.original_caption || (value?.caption && value.caption !== repostCaptionText)) && (
              <ReadMore text={value.original_caption || value.caption} />
            )}
          </div>
        </div>
      )}

      {renderClinicalContent()}
      {renderWebinarContent()}
      {renderPollContent()}
      {value.type !== "webinar" &&
        <PostFooter
          likes_count={value.likes_count}
          setPostId={setPostId}
          original_id={value.original_id}
          handleLikeUsers={handleLikeUsers}
          like_users_images={value.like_users_images}
          handleLike={handleLike}
          isLike={Boolean(value.isLike || value.reaction || value.user_reaction)}
          handleGetComments={handleGetComments}
          setPostModal={setPostModal}
          comments_count={value.comments_count}
          handleRepost={handleRepost}
          isShare={value.isShare}
          isSave={value.isSave}
          handleSave={handleSave}
          shares_count={value.shares_count ?? value.share_count ?? value.reposts_count ?? value.shares}
          type={value.type}
          value={value}
          refetch={refetch}
          pollData={value}
        />}

      {pdfModalOpen && (
        <Modal
          isOpen={pdfModalOpen}
          centered
          toggle={closeModal}
          size={isFullScreen ? "lg" : "lg"}
          className={isFullScreen ? "fullscreen-modal" : ""}
          style={
            isFullScreen
              ? { maxWidth: "100vw", maxHeight: "100vh", margin: 0 }
              : {}
          }
        >
          <ModalBody className="modal-body-view">

            {fileToView && fileToView?.type === "pdf" && (
              <div
                className={`position-relative custom_pdf_viewer ${isFullScreen ? "full-screen" : ""
                  }`}
                style={{ transition: "all 0.3s ease-in-out" }}
              >
                <div className="position-relative custom_pdf_viewer">
                  <div
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: isFullScreen ? "46px" : "40px", // Toolbar height
                      background: "white",
                      zIndex: 1000,
                      display: "flex", // Use flex to align content
                      justifyContent: "center", // Center horizontally
                      alignItems: "center", // Center vertically
                      padding: "0 10px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <h4
                        style={{
                          margin: 0,
                          padding: 0,
                          fontWeight: "bold",
                          color: "#333",
                          flexGrow: 1, // This ensures the heading takes available space and pushes the X button to the right
                          textAlign: "center",
                        }}
                      >
                        Case Study PDF
                      </h4>
                    </div>
                    <hr />
                  </div>

                  <iframe
                    title="PDF Viewer"
                    src={`${_imagesURL + fileToView?.media
                      }#toolbar=0&navpanes=0&scrollbar=0&view=FitH&messages=0&print=0&download=0`}
                    width="100%"
                    height="500px"
                    className={isChrome ? "mt-5" : ""}
                    style={{ border: "none" }}
                  />
                  <span
                    title={isFullScreen ? "Exit full screen" : "Full Screen"}
                    onClick={() => {
                      toggleFullScreen();
                    }}
                    className="position-absolute cursor text-white px-2 py-1"
                    style={{
                      borderRadius: "5px",
                      top: "0px",
                      right: "0px",
                      zIndex: 99999,
                    }}
                  >
                    {isFullScreen ? (
                      <IoCloseSharp className="fs-3 text-black" />
                    ) : (
                      <GoScreenFull className="fs-3 text-black" />
                    )}
                  </span>
                </div>
              </div>
            )}
          </ModalBody>
        </Modal>
      )}

    </div>
  );
};

export default PostCard;